export default "__VITE_ASSET__DONR5nPb__"